import type {BadgeColorScheme} from 'platform/components';
import {ThemeColorPath} from 'platform/foundation';
import {match} from 'ts-pattern';

/**
 * Maps color scheme to theme color path
 *
 * @param colorScheme - The color scheme type; schemes the calendar does not use fall back to neutral
 * @returns Theme color path for the given scheme
 *
 * @example
 * ```ts
 * const colorPath = getColorPathByScheme('blue');
 * // Returns 'palettes.blue.70.100'
 * ```
 */
export function getColorPathByScheme(colorScheme: BadgeColorScheme): ThemeColorPath {
  return match<BadgeColorScheme, ThemeColorPath>(colorScheme)
    .with('neutral', () => 'palettes.neutral.300.100')
    .with('blue', () => 'palettes.blue.70.100')
    .with('orange', () => 'palettes.orange.60.100')
    .with('green', () => 'palettes.green.60.100')
    .with('purple', () => 'palettes.purple.60.100')
    .with('red', () => 'palettes.red.60.100')
    .otherwise(() => 'palettes.neutral.300.100');
}
